import emojiRegex from 'emoji-regex';

const skinTones = ['', '-1f3fb', '-1f3fc', '-1f3fd', '-1f3fe', '-1f3ff'];

export function getIndexOfSkinTone(input) {
  return skinTones.findIndex((tone) => input.indexOf(tone) > 0) + 1;
}

export function emojiFromString(stringInput) {
  if (stringInput) {
    const regex = emojiRegex();
    const input = stringInput.replace('U+', '');
    const inputArr = input.split('-').map((item) => parseInt(item, 16));
    let skinToneIndex = 0;
    if (inputArr.length > 1) {
      skinToneIndex = getIndexOfSkinTone(input);
    }
    const emoji = String.fromCodePoint(...inputArr);
    return emoji.match(regex) ? { emoji, skinToneIndex } : null;
  }
  return null;
}

export function createFilterData(selectedType, selected) {
  // Create Filter
  switch (selectedType) {
    case 'tags':
      return selected.map((id) => ({ id })).toArray();
    case 'payees':
      return selected.toArray();
    case 'categories':
      return selected
        .toArray()
        .map((item) =>
          item === 'UNCATEGORIZED' || item === '0'
            ? { id: '0', type: 'UNCATEGORIZED' }
            : { id: item, type: 'CATEGORY' },
        );
    default:
      return null;
  }
}
